import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const issuesTableColumns: ITableColumn[] = [
  {
    labelPath: 'issuesPage.gridColumns.name',
    propertyKey: 'name',
    colType: TableColumnTypeEnum.TextWithIconAndTooltip,
    width: 350,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'displayName',
  },
  {
    labelPath: 'issuesPage.gridColumns.severity',
    propertyKey: 'severity',
    colType: TableColumnTypeEnum.SeverityLabel,
    width: 120,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'severity',
    invertSortIcon: true,
  },
  {
    labelPath: 'issuesPage.gridColumns.primaryResource',
    propertyKey: 'primaryResource',
    colType: TableColumnTypeEnum.TextWithIcon,
    width: 200,
    widthType: WidthType.Pixel,
    iconSrc: 'primaryResourceIcon',
    isSortable: true,
    sortKey: 'primaryResource',
  },
  {
    labelPath: 'issuesPage.gridColumns.status',
    propertyKey: 'status',
    colType: TableColumnTypeEnum.StatusLabel,
    width: 120,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'status',
  },
  {
    labelPath: 'issuesPage.gridColumns.firstSeen',
    propertyKey: 'firstSeen',
    colType: TableColumnTypeEnum.DateTime,
    width: 150,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'firstSeen',
  },
  {
    labelPath: 'issuesPage.gridColumns.lastSeen',
    propertyKey: 'lastSeen',
    colType: TableColumnTypeEnum.DateTime,
    width: 150,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'lastSeen',
  },
  {
    labelPath: 'issuesPage.gridColumns.correlations',
    propertyKey: 'correlations',
    colType: TableColumnTypeEnum.Text,
    width: 140,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'issuesPage.gridColumns.labels',
    propertyKey: 'labels',
    colType: TableColumnTypeEnum.Tag,
    width: 140,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
];
